import React from 'react';
import i18next from 'i18next';
import { FOOTER_NOTICE } from '../../components/layouts/content2';

// Selector EN/ES compartido por el home y las subcategorias
export function LangToggle({ langEng }) {
    const option = (code, label, flag) => {
        const active = (code === 'en') === langEng;

        return (
            <div
                onClick={() => i18next.changeLanguage(code)}
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 6,
                    padding: '6px 10px',
                    borderRadius: 7,
                    background: active ? '#fff' : 'transparent',
                    color: active ? '#000' : '#fff',
                    fontSize: 'clamp(16px, 2.4vw, 30px)',
                    fontWeight: 500,
                    lineHeight: 1,
                    cursor: 'pointer',
                    userSelect: 'none',
                    WebkitTapHighlightColor: 'transparent'
                }}
            >
                <img src={flag} alt={label} style={{ width: '1em', height: '1em', borderRadius: '50%', objectFit: 'cover' }} />
                {label}
            </div>
        );
    };

    return (
        <div style={{ display: 'flex', background: '#000', border: '2px solid #fff', borderRadius: 10, padding: 2 }}>
            {option('en', 'EN', require('../../assets/icons/english.png'))}
            {option('es', 'ES', require('../../assets/icons/spanish.png'))}
        </div>
    );
}

// Header de las pantallas internas: Ir atras, logo y selector EN/ES
export function ScreenHeader({ langEng, onBack }) {
    return (
        <div style={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}>
            <div style={{ flex: 1 }}>
                <div
                    onClick={onBack}
                    style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: 12,
                        padding: '14px 26px',
                        borderRadius: 16,
                        background: '#000',
                        color: '#fff',
                        fontFamily: 'Noodle',
                        fontSize: 'clamp(24px, 3.4vw, 44px)',
                        lineHeight: 1,
                        textTransform: 'uppercase',
                        cursor: 'pointer',
                        userSelect: 'none',
                        WebkitTapHighlightColor: 'transparent'
                    }}
                >
                    <span>←</span>
                    {langEng ? 'Go back' : 'Ir atrás'}
                </div>
            </div>

            <img
                src={require('./assets/home/logo.png')}
                alt="Habaneros"
                style={{ height: '11vh', width: 'auto', objectFit: 'contain', pointerEvents: 'none' }}
            />

            <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
                <LangToggle langEng={langEng} />
            </div>
        </div>
    );
}

// Pantalla de subcategorias (Food Menu / Drinks): grilla de 2 columnas con los
// botones del diseño; los marcados `wide` ocupan toda la fila.
function Subcategories({ buttons, images, langEng, onBack, onSelect }) {
    return (
        <div
            onContextMenu={(e) => e.preventDefault()}
            style={{
                position: 'fixed',
                inset: 0,
                zIndex: 2,
                display: 'flex',
                flexDirection: 'column',
                boxSizing: 'border-box',
                padding: '2.5vh 7% 2vh',
                backgroundColor: '#f2f2f2',
                backgroundImage: `url(${require('./assets/home/background.png')})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center'
            }}
        >
            <ScreenHeader langEng={langEng} onBack={onBack} />

            <div style={{ flex: 1, minHeight: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <div
                    style={{
                        display: 'grid',
                        gridTemplateColumns: 'auto auto',
                        justifyContent: 'center',
                        columnGap: '2.5vw',
                        rowGap: '1.8vh'
                    }}
                >
                    {buttons.map((button) => (
                        <div
                            key={button.key}
                            style={{
                                gridColumn: button.wide ? '1 / -1' : 'auto',
                                display: 'flex',
                                justifyContent: 'center'
                            }}
                        >
                            <img
                                src={images(`./${button.key}.png`)}
                                alt={button.category}
                                onClick={() => onSelect(button)}
                                style={{
                                    height: '9vh',
                                    maxWidth: '100%',
                                    objectFit: 'contain',
                                    cursor: 'pointer',
                                    WebkitTapHighlightColor: 'transparent'
                                }}
                            />
                        </div>
                    ))}
                </div>
            </div>

            <p
                style={{
                    margin: 0,
                    flexShrink: 0,
                    textAlign: 'center',
                    fontFamily: 'Noodle',
                    fontSize: 'clamp(12px, 1.3vw, 17px)',
                    lineHeight: 1.15,
                    letterSpacing: 0.5,
                    color: '#000',
                    textTransform: 'uppercase'
                }}
            >
                {langEng ? FOOTER_NOTICE.en : FOOTER_NOTICE.es}
            </p>
        </div>
    );
}

export default Subcategories;
